export const ChooseAsRewrite = () => {
    return (
        <div className="container">
            <h2>選択リライト自分</h2>
           <h3>使い方</h3>
            <p>現在は使えません</p>
        </div>
    )
}